"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// 包含 mpay, npay, pay 域名
var hosts = {
    product: /pay.meituan.com/,
    staging: /pay.test.meituan.com|pay.st.sankuai.com/,
    test: /pay.paymt.paydev.sankuai.com|pay.dev.sankuai.com/,
    qa: /pay.qa.pay.test.sankuai.com|pay.test.sankuai.com/
};
function getTestEnvironment() {
    var host = location.hostname;
    var envs = Object.keys(hosts);
    for (var i = 0; i < envs.length; i++) {
        if (hosts[envs[i]].test(host)) {
            return envs[i];
        }
    }
    return 'product';
}
exports.getTestEnvironment = getTestEnvironment;
